import { CleanHtml } from '@components/cleanHtml';
import { useEffect, useMemo } from 'react';
import { ErrorPageButtons, getErrorFragments, wrapMessage } from './lib';

export const ErrorPage: React.FC<IErrorPageProps> = ({ error }) => {
  useEffect(() => {
    document.body.classList.add('errorPage');
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('errorPage');
    };
  }, []);

  const errorObj = useMemo(() => {
    if ('source' in error && error.source?.errors?.[0]) {
      return error.source.errors[0];
    }

    return error as IErrorObjectProps;
  }, [error]);

  const { title, message, buttons } = useMemo(() => getErrorFragments(errorObj), [errorObj]);

  return (
    <div className="absolute inset-0 flex flex-col justify-center items-center bg-[#6a6a6a] bg-[url(/static/front/assets/background/error-background.jpg)] bg-center bg-cover">
      <span className="absolute right-5 bottom-4 z-100 text-xl font-normal uppercase text-white/50 max-[600px]:hidden errorPage-tagline">Geld. Und wie man es behält.</span>
      <a
        href="/"
        title="Home"
        className="block absolute left-1/2 top-[10%] z-110 h-[70px] w-[300px] -ml-[150px] bg-[url(/static/front/assets/logo-white.png)] bg-center bg-size-[300px_70px] bg-no-repeat max-[600px]:static max-[600px]:left-auto max-[600px]:top-auto max-[600px]:mx-0 max-[600px]:mt-[-30px] max-[600px]:mb-[30px] max-[600px]:h-[46px] max-[600px]:w-[200px] max-[600px]:bg-size-[200px_46px]"
      >
        <span className="sr-only">Home</span>
      </a>
      <div className="w-4/5 max-w-[500px] bg-white/15 px-[90px] py-20 max-[600px]:px-8 max-[600px]:py-5 [&_h1]:mb-5 [&_p]:mb-5 [&_h1]:text-white [&_p]:text-white [&_h1]:text-2xl [&_h1]:font-normal [&_h1]:uppercase [&_h1]:leading-tight [&_h1]:tracking-wide [&_h1]:font-[BonnCaps,Arial,sans-serif] [.no-bonncapps_&_h1]:font-[Arial,sans-serif] max-[600px]:[&_h1]:mb-2 max-[600px]:[&_p]:mb-2 max-[600px]:[&_h1]:text-base [&_p:last-child]:mb-0 [&_a]:uppercase [&_a]:font-[BonnCaps,Arial,sans-serif] [&_a]:text-base [&_a]:tracking-wide [&_a]:no-underline [&_a]:leading-normal [.no-bonncapps_&_a]:font-[Arial,sans-serif] [&_a:hover]:underline">
        <h1>{title}</h1>
        <CleanHtml html={wrapMessage(message || '')} allowedTags={['p', 'a', 'i', 'b', 'strong', 'em', 'br']} />
        <ErrorPageButtons buttons={buttons} />
      </div>
    </div>
  );
};
